export const setUrlCallbackLogin = () => {
  let arrayUrl = window.location.href.split('/');
  arrayUrl.splice(0, 3);
  arrayUrl = arrayUrl.join('/');
  return `/${arrayUrl}`;
  //console.log(`/${arrayUrl}`);
};
